import { z } from 'zod';

export const CetopicsScalarFieldEnumSchema = z.enum(['topicId','cityId','topicName','nextReminder','whenDue','templateCode','displayOrder','fieldAttributes','empFaqText']);

export default CetopicsScalarFieldEnumSchema;
